import React from 'react';
import Card from '../../../../components/Card';
import CardHeader from '../../../../components/CardHeader';
import styled from 'styled-components';
import BarGraph from '../../../../components/Charts/BarGraph';
import moment from 'moment';
import ExportButton from '../../../../components/Export';
import { I18n } from 'react-redux-i18n';

const NumberSellerCardContainer = styled.div`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  .exportButtonContainer {
    padding-bottom: 10px;
    margin-top: 10px;
  }

  .recharts-cartesian-axis-tick {
    font-size: 10px;
  }

  .nscTooltipContainer {
    min-width: 250px;
    width: calc(100% - 40px);
    display: flex;
    flex-direction: row;
    align-items: center;
    font-family: ${(props) => props.theme.fonts.sfcompact};
    font-size: 12px;
    padding: 20px;
  }

  .nscTooltipDate {
    color: #abb5be;
    text-transform: uppercase;
  }

  .nscTooltipValue {
    text-transform: uppercase;
    margin-left: auto;
    font-family: ${(props) => props.theme.fonts.sfcompact_text};
    font-weight: 600;
  }
`;

const TickContainer = styled.text`
  font-family: ${(props) => props.theme.fonts.sfcompact_text};
  fill: #1f2b37;
  font-size: 12px;
`;

class NumberSellerCard extends React.Component {
  constructor(props) {
    super(props);

    this.state = { hoverExport: false };
  }

  renderTickAxis = ({ x, y, payload, paddingRight, paddingTop }) => (
    <TickContainer x={x - paddingRight} y={y + paddingTop}>
      {payload.value}
    </TickContainer>
  );

  getNameWine() {
    const { data } = this.props;
    return data && data.length > 0
      ? `${data[0].wine_name} ${data[0].vintage}`
      : 'Aucun vin sélectionné';
  }

  formatData() {
    const { data } = this.props || [];
    return data.map((item) => ({
      name: moment(item.date).locale('fr').format('DD/MM'),
      value: item.dn
    }));
  }

  getOptions() {
    return [{ label: 'JPEG', value: 'JPEG' }];
  }

  renderTooltip(data) {
    return (
      data && (
        <div className="nscTooltipContainer">
          <p className="nscTooltipDate">
            {I18n.t('primeur.recap.barGraph.tooltipLabel')} {data.name}
          </p>
          <p className="nscTooltipValue">{data.value}</p>
        </div>
      )
    );
  }

  render() {
    const formattedData = [this.formatData()];
    const nameWine = this.getNameWine();
    return (
      <NumberSellerCardContainer id="recap-number-seller">
        <Card>
          <CardHeader
            title={I18n.t('primeur.recap.barGraph.title')}
            iconRight
            fontSize="20px"
            rightComponents={
              <ExportButton
                jpg
                pdf
                name="evolution-nombre-vendeur"
                targetElement="#recap-number-seller"
              />
            }
          />
          <BarGraph
            data={formattedData}
            height={312}
            xAxisProps={{
              minTickGap: 10,
              interval: 'preserveStartEnd',
              tick: (props) =>
                this.renderTickAxis({
                  ...props,
                  paddingTop: 8,
                  paddingRight: 30
                })
            }}
            yAxisProps={{
              width: 45,
              scale: 'linear',
              domain: [0, (dataMax) => (dataMax + 5).toFixed(0)],
              tick: (props) =>
                this.renderTickAxis({
                  ...props,
                  paddingTop: 3,
                  paddingRight: 30
                })
            }}
            renderTooltip={(props) => this.renderTooltip(props[0])}
            tooltipOffset={{ x: 42, y: 35 }}
            customLegendProps={{
              styles: `.itemContainer{font-size:10px;text-transform:normal;}`
            }}
            showName={false}
            labels={[
              `${I18n.t('primeur.recap.barGraph.nbSeller')} ${nameWine}`
            ]}
            colors={Array(formattedData[0].length).fill('#e25d34')}
          />
        </Card>
      </NumberSellerCardContainer>
    );
  }
}

export default NumberSellerCard;
